import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import axios from 'axios';
import { FolderOpen, FileText, MessageSquare, TrendingUp } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AdminDashboard = () => {
  const [stats, setStats] = useState({
    total_projects: 0,
    total_posts: 0,
    total_messages: 0,
    new_messages: 0,
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      const token = localStorage.getItem('admin_token');
      const response = await axios.get(`${API}/stats`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setStats(response.data);
    } catch (error) {
      console.error('Error fetching stats:', error);
    } finally {
      setLoading(false);
    }
  };

  const statCards = [
    {
      title: 'Proyectos',
      value: stats.total_projects,
      icon: FolderOpen,
      color: 'text-editorial',
    },
    {
      title: 'Artículos',
      value: stats.total_posts,
      icon: FileText,
      color: 'text-ink',
    },
    {
      title: 'Mensajes',
      value: stats.total_messages,
      icon: MessageSquare,
      color: 'text-ink',
    },
    {
      title: 'Nuevos Mensajes',
      value: stats.new_messages,
      icon: TrendingUp,
      color: 'text-editorial',
    },
  ];

  return (
    <div data-testid="admin-dashboard">
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
        <h1 className="text-4xl font-bold tracking-tight mb-2" data-testid="dashboard-title">
          Dashboard
        </h1>
        <p className="text-sm font-sans tracking-widest uppercase text-ink/60 mb-12">Panel de Control</p>
      </motion.div>

      {loading ? (
        <div className="text-center py-20">
          <p className="text-lg font-light text-ink/60">Cargando estadísticas...</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {statCards.map((stat, index) => {
            const Icon = stat.icon;
            return (
              <motion.div
                key={stat.title}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1, duration: 0.6 }}
                className="bg-paper p-6 editorial-border"
                data-testid={`stat-card-${stat.title.toLowerCase()}`}
              >
                <div className="flex items-center justify-between mb-4">
                  <Icon className={`w-8 h-8 ${stat.color}`} />
                </div>
                <p className="text-4xl font-bold tracking-tight mb-2">{stat.value}</p>
                <p className="text-sm font-sans tracking-widest uppercase text-ink/60">{stat.title}</p>
              </motion.div>
            );
          })}
        </div>
      )}

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.5, duration: 0.6 }}
        className="mt-12 bg-paper p-8 editorial-border"
      >
        <h2 className="text-2xl font-bold tracking-tight mb-4">Bienvenido</h2>
        <p className="text-lg font-light leading-relaxed text-ink/70">
          Este es tu panel de administración. Desde aquí puedes gestionar proyectos, artículos de blog, mensajes de
          contacto y categorías.
        </p>
      </motion.div>
    </div>
  );
};

export default AdminDashboard;